var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linkedin"},[_c('span',[_vm._v(_vm._s(_vm.code && _vm.success ? "Success" : "Error"))])])}
var staticRenderFns = []

export { render, staticRenderFns }